// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SgSR","rootMobile":"styles_rootMobile__2R99T"};